import { Modal, Row, Col, Empty } from "antd";
import { Flex, Box, Text } from "@chakra-ui/react";
import PrimaryButton from "components/Button/PrimaryButton";
import ContentItem from "components/ContentItem";
import useUnidadePessoasDetalhes from "core/features/unidades/useUnidadePessoasDetalhes";
import moment from "moment";
import { useLoading } from "infra/helpers/alerta";
import TableContatos from "./components/TabelaContatos";
import { formatCNPJ } from "@brazilian-utils/brazilian-utils";
import { formatCPF } from "@brazilian-utils/brazilian-utils";

interface ModalContentPessoaProps {
  isOpenModal: boolean;
  onClose: () => any;
  unidadeId: string;
  id?: string | null;
}

export default function ModalContentPessoa({
  isOpenModal,
  onClose,
  unidadeId,
  id,
}: ModalContentPessoaProps) {
  const { data, isLoading } = useUnidadePessoasDetalhes(unidadeId, id);

  useLoading(isLoading);

  const isOutros = data?.tipoUnidadePessoa === "Outros" ?? true;
  const isJuridico = data?.isJuridico;

  const getSexo = (value: string) => {
    switch (value) {
      case "f":
        return "Feminino";
      case "m":
        return "Masculino";
      case "o":
        return "Outro";
      default:
        return null;
    }
  };

  return (
    <Modal
      centered
      destroyOnClose
      width="900px"
      title={`Detalhe da Pessoa`}
      footer={
        <Flex flex={1} justifyContent="end" gap={4}>
          <PrimaryButton onClick={onClose}>Fechar</PrimaryButton>
        </Flex>
      }
      visible={isOpenModal}
      onCancel={onClose}
    >
      {!isLoading ? (
        <>
          <Box as={Row} gutter={8} mb={4}>
            <Box as={Col} sm={12}>
              <ContentItem
                fontSizeTitulo="12px"
                fontSizeDescricao="14px"
                titulo={isJuridico ? "Nome Fantasia:" : "Nome:"}
                descricao={data?.nome || "--"}
              />
            </Box>
            {isJuridico ? (
              <Box as={Col} sm={12}>
                <ContentItem
                  fontSizeTitulo="12px"
                  fontSizeDescricao="14px"
                  titulo={"Razão Social:"}
                  descricao={data?.razaoSocial || "--"}
                />
              </Box>
            ) : (
              <Box as={Col} sm={12}>
                <ContentItem
                  fontSizeTitulo="12px"
                  fontSizeDescricao="14px"
                  titulo={"E-mail:"}
                  descricao={data?.email || "--"}
                />
              </Box>
            )}
          </Box>

          <Box as={Row} gutter={8} mb={4}>
            <Box as={Col} sm={6}>
              <ContentItem
                fontSizeTitulo="12px"
                fontSizeDescricao="14px"
                titulo={isJuridico ? "CNPJ:" : "CPF:"}
                descricao={
                  isJuridico
                    ? formatCNPJ(data?.documento!)
                    : formatCPF(data?.documento!) || "--"
                }
              />
            </Box>

            {!isJuridico ? (
              <>
                {!isOutros ? (
                  <Box as={Col} sm={6}>
                    <ContentItem
                      fontSizeTitulo="12px"
                      fontSizeDescricao="14px"
                      titulo={"RG:"}
                      descricao={data?.rg || "--"}
                    />
                  </Box>
                ) : null}
                <Box as={Col} sm={6}>
                  <ContentItem
                    fontSizeTitulo="12px"
                    fontSizeDescricao="14px"
                    titulo={"Data de Nascimento:"}
                    descricao={
                      data?.dataNascimento
                        ? `${moment(data?.dataNascimento).format("DD/MM/YYYY")}`
                        : "--"
                    }
                  />
                </Box>
                <Box as={Col} sm={6}>
                  <ContentItem
                    fontSizeTitulo="12px"
                    fontSizeDescricao="14px"
                    titulo={"Sexo:"}
                    descricao={getSexo(data?.sexo!) || "--"}
                  />
                </Box>
              </>
            ) : (
              <>
                {" "}
                <Box as={Col} sm={6}>
                  <ContentItem
                    fontSizeTitulo="12px"
                    fontSizeDescricao="14px"
                    titulo={"Inscrição Estadual:"}
                    descricao={data?.inscricaoEstadual || "--"}
                  />
                </Box>
                <Box as={Col} sm={6}>
                  <ContentItem
                    fontSizeTitulo="12px"
                    fontSizeDescricao="14px"
                    titulo={"Inscrição Municipal:"}
                    descricao={data?.inscricaoMunicipal || "--"}
                  />
                </Box>{" "}
              </>
            )}
          </Box>

          <Box as={Row} gutter={8} mb={4}>
            {isOutros ? (
              <>
                <Box as={Col} sm={6}>
                  <ContentItem
                    fontSizeTitulo="12px"
                    fontSizeDescricao="14px"
                    titulo={"Pessoa vinculada:"}
                    descricao={data?.pessoaVinculada || "--"}
                  />
                </Box>
                <Box as={Col} sm={6}>
                  <ContentItem
                    fontSizeTitulo="12px"
                    fontSizeDescricao="14px"
                    titulo={"Tipo do vínculo:"}
                    descricao={data?.tipoVinculoPessoa || "--"}
                  />
                </Box>
              </>
            ) : !isJuridico ? (
              <Box as={Col} sm={6}>
                <ContentItem
                  fontSizeTitulo="12px"
                  fontSizeDescricao="14px"
                  titulo={"Profissão:"}
                  descricao={data?.profissao || "--"}
                />
              </Box>
            ) : null}
          </Box>

          <Box as={Row} gutter={8} mb={4}>
            <Box as={Col} sm={6}>
              <ContentItem
                fontSizeTitulo="12px"
                fontSizeDescricao="14px"
                titulo={"Data de fim do acesso a unidade:"}
                descricao={
                  data?.dataFimAcesso
                    ? `${moment(data?.dataFimAcesso).format("DD/MM/YYYY")}`
                    : "--"
                }
              />
            </Box>
          </Box>

          <Box as={Row} gutter={8} mb={4}>
            <Box as={Col} sm={24}>
              <ContentItem
                fontSizeTitulo="12px"
                fontSizeDescricao="14px"
                titulo={"Observação:"}
                descricao={data?.observacao || "--"}
              />
            </Box>
          </Box>
          <Text fontWeight="medium" fontSize={18} mb={4}>
            Contatos
          </Text>
          {data?.contatos.length ? (
            <TableContatos data={data} />
          ) : (
            <Empty description={"Sem contatos cadastrados"} />
          )}
        </>
      ) : null}
    </Modal>
  );
}
